import { useContext, useMemo } from 'react';
import { useQuery } from 'react-query';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import * as api from '../../services/api';
import { QUERY_CACHE_TIME } from '../../constants';

export const REQUESTS_COLORS = [
  { color: '#ff77a3', background: '#ffd4e2' },
  { color: '#7788ff', background: '#dee2fe' },
  { color: '#5a93ff', background: '#deeaff' }
];

export const RequestTypes = {
  ABSENCE: 1,
  GENERAL_AVAILABILITY: 2,
  RELEASE_SHIFT: 3,
  SWAP_SHIFT: 4,
  LEAVE_REQUEST: 5
};

export const RequestTypesSlugs = {
  ABSENCE: 'absence',
  GENERAL_AVAILABILITY: 'general-availability',
  RELEASE_SHIFT: 'release-shift',
  SWAP_SHIFT: 'shift-swap',
  LEAVE_REQUEST: 'leave-request'
};

export const RequestAbsenceKinds = {
  WORK_FROM_HOMR: 'work-from-home'
};

export const TYPES_COLROS = {
  [RequestTypes.SWAP_SHIFT]: { color: '#b929ff', background: 'rgba(185, 41, 255, 0.1)' },
  [RequestTypes.RELEASE_SHIFT]: { color: '#db6b12', background: '#ffdfc3' },
  [RequestTypes.GENERAL_AVAILABILITY]: { color: '#ff3f6d', background: 'rgba(255, 63, 109, 0.2)' },
  [RequestTypes.LEAVE_REQUEST]: { color: '#1aa39c', background: 'rgba(26, 163, 156, 0.15)' }
};

const useRequestsTypes = () => {
  const { t } = useContext(ConfigContext);
  const storeKey = ['requestsTypes'];
  const { isLoading, data } = useQuery(storeKey, api.fetchRequestsTypes, {
    cacheTime: QUERY_CACHE_TIME
  });

  const mappedRequestsTypes = useMemo(
    () =>
      (data?.data || []).reduce(
        (prev, { id, type, kinds }) => ({
          ...prev,
          [id]: {
            id,
            type,
            kinds: (kinds || []).reduce(
              (prevKinds, { id: kindId, slug }, index) => ({
                ...prevKinds,
                [kindId]: { label: t(slug), ...REQUESTS_COLORS[index % REQUESTS_COLORS.length] }
              }),
              {}
            )
          }
        }),
        {}
      ),
    [data?.data, t]
  );

  const mappedRequestsTypesBySlug = useMemo(
    () =>
      (data?.data || []).reduce((all, curr) => {
        all[curr.type] = curr;
        return all;
      }, {}),
    [data?.data]
  );

  return { isLoading, requestTypes: data?.data || [], mappedRequestsTypes, mappedRequestsTypesBySlug };
};

export default useRequestsTypes;
